import React from "react";
import { useLocalization } from "@i18n";
import { GeneralDashboardCard } from "./GeneralDashboardCard";
import { GeneralDashboardFieldStack } from "./GeneralDashboardFieldStack";

interface GeneralRaisingHistoryCardProps {
  data: { items: Record<string, unknown>[] } | null;
  onMenuClick: () => void;
}

export const GeneralRaisingHistoryCard: React.FC<GeneralRaisingHistoryCardProps> = ({
  data,
  onMenuClick,
}) => {
  const { translate } = useLocalization();

  const item = data?.items && data.items.length > 0 ? data.items[0] : null;

  const getMethodLabel = (method: string) => {
    if (!method) return "—";
    const key = `admin.structures.raisingHistory.method.${method}`;
    const translated = translate(key);
    return translated === key ? method : translated;
  };

  const fields = item
    ? [
        {
          labelKey: "admin.structures.raisingHistory.label.executiveProjectDesigner",
          value: item.executiveProjectDesigner,
        },
        {
          labelKey: "admin.structures.raisingHistory.label.stage",
          value: item.stage,
        },
        {
          labelKey: "admin.structures.raisingHistory.label.method",
          value: getMethodLabel(typeof item.method === "string" ? item.method : ""),
        },
        {
          labelKey: "admin.structures.raisingHistory.label.elevation",
          value: item.elevation,
        },
        {
          labelKey: "admin.structures.raisingHistory.label.occurredOn",
          value: item.occurredOn,
          isDate: true,
        },
      ]
    : [];

  return (
    <GeneralDashboardCard
      title={translate("general.dashboard.raisingHistory.title")}
      titleVariant="large"
      onMenuClick={onMenuClick}
      className="h-full"
      menuTestId="more-options-hist-rico-de-alteamento"
    >
      {item ? (
        <GeneralDashboardFieldStack fields={fields} />
      ) : (
        <div className="flex h-full flex-1 items-center justify-center text-sm text-muted-foreground">
          {translate("general.dashboard.emptyValue")}
        </div>
      )}
    </GeneralDashboardCard>
  );
};
